"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/userProfile/subscriptionRank.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class SubscriptionRank extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(SubscriptionRank), "SubscriptionRank", ["tierName", "tierClass"]);
            this.TestDatas = SubscriptionRank.TestDatas;
            this.BindedLists = SubscriptionRank.BindedLists;
            this.BindedWidgets = SubscriptionRank.BindedWidgets;
            this.InitialData = SubscriptionRank.InitialData;
            this.path = SubscriptionRank.path;
            this.GeneratedConstructor = SubscriptionRank;
            if (SubscriptionRank.InitialData) {
                this.renderRecursive(SubscriptionRank.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.SubscriptionRank",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("a", { "href": { "name": "href", "templates": [{ "type": "raw", "content": "/dashboard/profile?section=subscription" }] }, "target": { "name": "target", "templates": [{ "type": "raw", "content": "_blank" }] }, "rel": { "name": "rel", "templates": [{ "type": "raw", "content": "noopener" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "subscription-rank-b0a50e " }, { "type": "value", "content": "tierClass", "reverse": false }] }, "aria-label": { "name": "aria-label", "templates": [{ "type": "raw", "content": "Current subscription tier" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }, { "type": "value", "content": "tierName", "reverse": false }, { "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = []; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/userProfile/subscriptionRank"; }
        static { this.widgetName = "SubscriptionRank"; }
        static { this.InitialData = null; }
    }
    R.SubscriptionRank = SubscriptionRank;
    SubscriptionRank["prototype"].widgetName = "SubscriptionRank";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.subscription-rank-b0a50e {\n\n    & {\n        display: inline-flex;\n        align-items: center;\n        min-width: 0;\n        max-width: 112px;\n        padding: 3px 7px;\n        border-radius: 3px;\n        font-size: 11px;\n        font-weight: 600;\n        line-height: 18px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-decoration: none;\n        color: #b3b7bc;\n    }\n    &.tier-paid { color: #8bd9a9; }\n    &:hover { background: rgba(255, 255, 255, 0.08); }\n    &:focus-visible { outline: 2px solid currentColor; outline-offset: -2px; }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
